import { render, staticRenderFns } from "./Swish.vue?vue&type=template&id=6fdf9706"
import script from "./Swish.vue?vue&type=script&lang=js"
export * from "./Swish.vue?vue&type=script&lang=js"
import style0 from "./Swish.vue?vue&type=style&index=0&id=6fdf9706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports